/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Input, Select, Spin } from "antd";
import { useCallback,  useEffect, useState } from "react";
import {
  SearchOutlined,
  LoadingOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../model/application/state";
import {
  MerchantCategories,
  MerchantComission,
} from "./../../../service/action/merchant";
import SearchDatatable from "../../../shared/component/searchDatatable";
import { MerchantBillers } from "./../../../service/action/merchant";
import { MerchantLayoutContainer } from "../../../shared/layout/MerchantLayoutContainer";
import { DataTableUtil } from "../../../shared/component/data-table-util";
import { DataTable } from "../../../shared/component/data-table";
import { APIresponse } from "../../../model/client/response";

const antIcon = <LoadingOutlined style={{ fontSize: 20 }} spin rev={undefined} />;

export const MerchantCommission = () => {
  const dispatch = useDispatch();
  const [column, setColumn] = useState([] as any);
  const {
    merchantCommissionState,
    merchantCategoryState,
    merchantBillerState,
    userValidationState
  }: any = useSelector((state) => state);
  const merchantCommissionStates: State.MerchantCommission =
  merchantCommissionState;
  const category: State.ManageCategory = merchantCategoryState;
  const billerState: State.MerchantBiller = merchantBillerState;
  const state: State.UserValidation = userValidationState;
  
  const billerIndex = state?.response?.role?.permissions?.findIndex(x => x.name === "VIEW_BILLER");
  const categoryIndex = state?.response?.role?.permissions?.findIndex(x => x.name === "VIEW_CATEGORY");

  const GetMerchant = useCallback(
    (state: State.MerchantCommission) => {
      dispatch({
        type: MerchantComission.Set_GetMerchant_Commission_State,
        payload: {
          ...state,
        },
      });
    },
    [merchantCommissionStates]
  );

  const GetCategory = useCallback(() => {
    dispatch({
      type: MerchantCategories.Set_GetMerchant_Category_State,
      payload: {
        ...category,
      },
    });
  }, [category]);

  const GetBiller = useCallback(() => {
    dispatch({
      type: MerchantBillers.Set_GetMerchant_Biller_State,
      payload: {
        ...billerState,
      },
    });
  }, [billerState]);

  const Search = useCallback(
    async (value: string, state: State.MerchantCommission) => {
      const response = await SearchDatatable.Search(
        state.originalResponse,
        value
      );
      dispatch({
        type: MerchantComission.Set_Merchant_Commission_State,
        payload: {
          ...state,
          response,
        },
      });
    },
    [merchantCommissionStates]
  );


  const commissions = {
    title: "Commissions",
    dataIndex: "",
    width:"15%",
    key:"40",
    render: (_:any, record: APIresponse.MerchantCommission) => {
      return (
        <p>{record.commissionDTO?.value?.toFixed(5)}</p>
      )
    }
  }

  const minCap = {
    title: "Min Cap",
    dataIndex: "",
    width:"15%",
    key:"40",
    render: (_:any, record: APIresponse.MerchantCommission) => {
      return (
        <p>{record.commissionDTO?.minCap?.toFixed(5)}</p>
      )
    }
  }

  const maxCap = {
    title: "Max Cap",
    dataIndex: "",
    width:"15%",
    key:"40",
    render: (_:any, record: APIresponse.MerchantCommission) => {
      return (
        <p>{record.commissionDTO?.maxCap?.toFixed(5)}</p>
      )
    }
  }

  const convenienceFee = {
    title: "Max Cap",
    dataIndex: "",
    width:"15%",
    key:"40",
    render: (_:any, record: APIresponse.MerchantCommission) => {
      return (
        <p>{record.commissionDTO?.convenienceFee?.toFixed(5)}</p>
      )
    }
  }

  const setColumns = async () => {
    let columns = column;
    columns = [
      "key",
      "Biller Name_15%",
      "Commission Model",
    ];
    columns = DataTableUtil.SetColumn(columns);
    await setColumn(columns);
    columns.splice(2, 0, commissions)
    columns.splice(4, 0, minCap)
    columns.splice(5, 0, maxCap)
    columns.splice(6, 0, convenienceFee)
  };
   useEffect(() => {
    GetMerchant(merchantCommissionStates);
    GetCategory()
    GetBiller()
    setColumns();
  }, []);

  const searchCategory = useCallback(
    (categoryName: any) => {
      const categories = category.response.filter((x) => {
        return x.name === categoryName;
      })[0];
      const response = billerState.originalResponse?.filter((x) => {
        return x.categoryDTOS?.map((y) => y.name).includes(categories.name);
      });
      dispatch({
        type: MerchantBillers.Set_Merchant_Biller_State,
        payload: {
          ...billerState,
          response,
        },
      });
    },
    [category]
  );

  const billerSearch = useCallback(
    (billerName: any) => {
      const response = merchantCommissionStates.originalResponse?.filter(
        (x) => {
          return x.billerName === billerName;
        }
      );
      dispatch({
        type: MerchantComission.Set_Merchant_Commission_State,
        payload: {
          ...merchantCommissionStates,
          response,
        },
      });
    },
    [billerState]
  );

  return (
    <MerchantLayoutContainer
      defaultSelectedKeys="18"
      pageTitle="Commission"
    >
      <div className="filter-section">
        <span style={{ display: "flex", gap: 50 }}>
          {
            categoryIndex && categoryIndex > 0 ?
          <span
            style={{
              display: "grid",
              placeItems: "start",
              color: "#575F6E",
            }}
          >
            Category
            <Select
              suffixIcon={<CaretDownOutlined style={{ color: "#575F6E" }} rev={undefined} />}
              onChange={(e) => searchCategory(e)}
              placeholder="All"
              style={{ width: 100 }}
            >
              {Array.isArray(category?.response)
                ? category?.response.map((x, index) => (
                    <Select.Option key={index} value={x.name}>
                      {x.name}
                    </Select.Option>
                  ))
                : ""}
            </Select>
          </span> : ""
          }
          {
            billerIndex && billerIndex > 0 ?
          <span
            style={{
              display: "grid",
              placeItems: "start",
              color: "#575F6E",
            }}
          >
            Billers
            <Select
              suffixIcon={<CaretDownOutlined style={{ color: "#575F6E" }} rev={undefined} />}
              onChange={(e) => billerSearch(e)}
              placeholder="All"
              style={{ width: 100 }}
            >
              {Array.isArray(billerState?.response)
                ? billerState?.response.map((x, index) => (
                    <Select.Option key={index} value={x.name}>
                      {x.name}
                    </Select.Option>
                  ))
                : ""}
            </Select>
          </span> : ""
          }
        </span>
        <Input
          style={{
            width: 300,
            border: "1px solid grey",
            borderRadius: "50px",
            height: 35,
          }}
          onChange={(e) => {
            Search(e.target.value, merchantCommissionState);
          }}
          typeof="text"
          prefix={<SearchOutlined style={{ color: "grey" }} rev={undefined} />}
          placeholder="Search Commissions"
        />
      </div>
      <Divider />

      <div className="">
        <Spin
          size="small"
          indicator={antIcon}
          tip={"Getting Data..."}
          spinning={merchantCommissionStates.processing}
          style={{
            color: "green",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          data-aos="zoom-in-up"
        >
          <DataTable
            rows={merchantCommissionStates.response as any}
            columns={column}
          />
        </Spin>
      </div>
    </MerchantLayoutContainer>
  );
};
